import Vue from 'vue'

const state = {
  items: [] // Array para almacenar las noticias
}

const mutations = {
  // Mutación para inicializar las noticias (tipo 'init')
  'INIT_NEWS'(state, newsArray) {
    state.items = newsArray || []
  },

  // Mutación para agregar una nueva noticia al inicio (tipo 'news')
  'ADD_NEW_ITEM'(state, newsItem) {
    // Agregar al inicio del array
    state.items.unshift(newsItem)
  },

  // Mutación para eliminar una noticia por id_wp (tipo 'news_deleted')
  'REMOVE_NEWS_BY_ID_WP'(state, id_wp) {
    state.items = state.items.filter(noticia => noticia.id_wp !== id_wp)
  },

  // Mutación para actualizar una noticia existente
  'UPDATE_NEWS_ITEM'(state, { index, newsItem }) {
    Vue.set(state.items, index, newsItem)
  },

  // Mutación para marcar una noticia como leída
  'MARK_NEWS_AS_READ'(state, { id_wp }) {
    const index = state.items.findIndex(item => item.id_wp === id_wp)
    if (index !== -1) {
      // Usar Vue.set para reactividad
      Vue.set(state.items[index], 'viewedAt', new Date().toISOString())
    }
  },

  // Mutación para marcar una noticia como útil
  'MARK_NEWS_AS_USEFULL'(state, { id_wp, answer }) {
    const index = state.items.findIndex(item => item.id_wp === id_wp)
    if (index !== -1) {
      // Usar Vue.set para reactividad
      Vue.set(state.items[index], 'wasUsefull', answer)
    }
  },

  // Mutación para marcar todas como leídas
  'MARK_ALL_NEWS_AS_READ'(state) {
    const now = new Date().toISOString()
    state.items.forEach(item => {
      if (!item.viewed_at) {
        Vue.set(item, 'viewedAt', now)
      }
      if (item.read !== undefined) {
        Vue.delete(item, 'read')
      }
    })
  },

  // Mutación para limpiar todas las noticias
  'CLEAR_NEWS'(state) {
    state.items = []
  }
}


const actions = {
  // Acción para inicializar noticias (tipo 'init')
  initNews({ commit }, newsArray) {
    commit('INIT_NEWS', newsArray)
  },

  // Acción para agregar nueva noticia (tipo 'news')
  addNews({ commit }, newsItem) {
    commit('ADD_NEW_ITEM', newsItem)
  },

  // Acción para eliminar noticia por id_wp (tipo 'news_deleted')
  removeNewsByIdWp({ commit }, id_wp) {
    commit('REMOVE_NEWS_BY_ID_WP', id_wp)
  },

  // Acción para actualizar noticia
  updateNews({ commit }, { index, newsItem }) {
    commit('UPDATE_NEWS_ITEM', { index, newsItem })
  },

  // Acción para marcar como leída
  markNewsAsRead({ commit }, { id_wp }) {
    // Solo commit a la mutación - TODO LOCAL
    commit('MARK_NEWS_AS_READ', {
      id_wp,
      viewedAt: new Date().toISOString()
    })
  },

  // Acción para marcar como útil
  markNewsAsUsefull({ commit }, { id_wp, answer }) {
    // Solo commit a la mutación - TODO LOCAL
    commit('MARK_NEWS_AS_USEFULL', {
      id_wp,
      answer
    })
  },

  // Acción para marcar todas como leídas
  markAllNewsAsRead({ commit }) {
    commit('MARK_ALL_NEWS_AS_READ')
  },

  // Acción para limpiar todas
  clearNews({ commit }) {
    commit('CLEAR_NEWS')
  }
}

const getters = {
  // Obtener todas las noticias
  allNews: (state) => state.items,

  // Obtener noticias no leídas
  unreadNews: (state) => {
    return state.items.filter(item => !item.read)
  },

  // Obtener noticias leídas
  readNews: (state) => {
    return state.items.filter(item => item.read)
  },

  // Contar noticias no leídas
  unreadCount: (state) => {
    return state.items.filter(item => !item.read).length
  },

  // Obtener noticia por id_wp
  getNewsByIdWp: (state) => (id_wp) => {
    return state.items.find(item => item.id_wp === id_wp)
  },

  // Obtener noticias ordenadas por fecha (más recientes primero)
  sortedNews: (state) => {
    return [...state.items].sort((a, b) => {
      // Asegúrate de que las fechas existan
      const dateA = a.date || a.created_at || a.timestamp
      const dateB = b.date || b.created_at || b.timestamp

      if (!dateA || !dateB) return 0
      return new Date(dateB) - new Date(dateA)
    })
  },

  // Obtener noticias por tipo/categoría
  newsByType: (state) => (type) => {
    return state.items.filter(item => item.type === type)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}